import { useGameState } from '../../../net/GameProvider.js';
import { useI18n } from '../../../i18n.js';
import { CardUI } from '../../CardUI.js';

interface TwentyOneTableProps {
  isPaused: boolean;
}

export function TwentyOneTable({ isPaused }: TwentyOneTableProps) {
  const { state } = useGameState();
  const { lang } = useI18n();
  const isMn = lang === 'mn';
  const { game } = state;
  const twentyone = game?.twentyone ?? null;

  if (!game || !twentyone) return null;

  const bankerPlayer = game.players.find((p) => p.seat === twentyone.bankerSeat);

  return (
    <div className="center-trick-area">
      {/* Permanent table center watermark */}
      <img
        src="/card-table-center.svg"
        className="table-center-watermark"
        alt=""
        aria-hidden="true"
      />
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10, position: 'relative', zIndex: 1 }}>
        <div className="table-status">
          {/* Bank Pot Badge */}
          <div
            className="pot-stock-badge"
            title={isMn ? `Банкны сан: ${twentyone.bankPot} чип` : `Bank pot: ${twentyone.bankPot} chips`}
            style={{
              background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.25), rgba(217, 119, 6, 0.35))',
              border: '1px solid rgba(245, 158, 11, 0.6)',
              color: '#fef08a',
              padding: '6px 14px',
              borderRadius: 20,
              display: 'flex',
              alignItems: 'center',
              gap: 8,
            }}
          >
            <span style={{ fontSize: '1.2em' }}>🏦</span>
            <span className="pot-stock-label" style={{ fontWeight: 700 }}>
              {isMn ? 'Банк' : 'Bank'}:
            </span>
            <strong className="pot-stock-val" style={{ fontSize: '1.15em', color: '#fbbf24' }}>
              {twentyone.bankPot}
            </strong>
            <span style={{ fontSize: '0.85em', opacity: 0.85 }}>{isMn ? 'чип' : 'chips'}</span>
          </div>
        </div>

        {/* Stage Pill & Banker Info */}
        <div className="muushig-meta-bar" style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          <div className="muushig-role-summary">
            <span className="role-chip dealer" title={isMn ? 'Банкир' : 'Banker'}>
              👑 {isMn ? 'Банкир' : 'Banker'}: {bankerPlayer?.name ?? ''}
            </span>
          </div>
          <div
            className="table-phase"
            style={{
              background: 'rgba(0, 0, 0, 0.55)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              borderRadius: 12,
              padding: '3px 10px',
              fontSize: '0.82em',
              color: '#e2e8f0',
            }}
          >
            {twentyone.stage === 'betting'
              ? isMn
                ? '🪙 Бооцоо тавих үе'
                : '🪙 Betting Stage'
              : twentyone.stage === 'playing'
              ? isMn
                ? '🃏 Тоглогчид хөзөр татах'
                : '🃏 Player Drawing (Hit/Stand)'
              : twentyone.stage === 'banker'
              ? isMn
                ? '👑 Банкирын таталт'
                : "👑 Banker's Turn"
              : isMn
              ? '🏁 Тойрог дууссан'
              : '🏁 Round Finished'}
          </div>
        </div>

        {/* Banker Cards Display */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, marginTop: 4 }}>
          <div style={{ fontSize: '0.8em', color: '#cbd5e1', fontWeight: 600 }}>
            {isMn ? 'Банкирын гар' : "Banker's Hand"}
            {twentyone.bankerScore !== undefined && (
              <span
                style={{
                  marginLeft: 8,
                  color:
                    twentyone.bankerScore > 21
                      ? '#f87171'
                      : twentyone.bankerScore === 21
                      ? '#34d399'
                      : '#fbbf24',
                  fontWeight: 800,
                }}
              >
                ({twentyone.bankerScore > 21 ? (isMn ? 'Шатсан' : 'Busted') : `${twentyone.bankerScore} оноо`})
              </span>
            )}
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 6, minHeight: 64 }}>
            {twentyone.bankerHand && twentyone.bankerHand.length > 0 ? (
              twentyone.bankerHand.map((c, i) => (
                <CardUI
                  key={`banker-card-${c}-${i}`}
                  faceDown={isPaused}
                  cardCode={isPaused ? undefined : c}
                  className={i > 0 ? 'trick-card trick-card-overlap' : 'trick-card'}
                  style={{
                    transform: `rotate(${(i - (twentyone.bankerHand!.length - 1) / 2) * 4}deg)`,
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.4)',
                  }}
                />
              ))
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
